/**
 * Spec compartida para la importación de atributos extra de un layer.
 * El backend tiene su contraparte en app/Models/Services/Pictograms/ImportSpec.php
 * — cualquier cambio aquí debe replicarse allá.
 */
export const IMPORT_EXTRA_ATTRS_COLUMNS = [
  { key: 'id',                label: 'ID',                          required: true,  type: 'string' },
  { key: 'order_line_id',     label: 'Order Line ID',               required: true,  type: 'string'  },
  { key: 'purchase_order_id', label: 'Purchase Order ID',           required: false,  type: 'string'  },
  { key: 'motor_type',        label: 'Motor / Non-motor / Exterior',required: false, type: 'string'  },
  { key: 'foundation_type',   label: 'Foundation type',              required: false, type: 'string'  },
  { key: 'embedment_depth',   label: 'Embedment depth',             required: false, type: 'number'  },
  { key: 'section',           label: 'Section',                     required: false, type: 'string'  },
];

export const IMPORT_EXTRA_ATTRS_SCHEMA = IMPORT_EXTRA_ATTRS_COLUMNS.map(c => c.key);

/**
 * Número de filas de cabecera al inicio del Excel (no contienen datos).
 * Hoy es solo la fila 0 con los nombres de columnas. Si la plantilla cambia
 * y añades filas de metadatos arriba, ajusta este valor.
 */
export const IMPORT_EXTRA_ATTRS_HEADER_ROWS = 1;
